import MerchantDataLoader from './MerchantDataLoaderReal';
import PosSystemDataLoaderReal from '../../Settings/DataLoader/PosSystemDataLoaderReal';
import SettingsDataLoaderReal from '../../Settings/DataLoader/SettingsDataLoaderReal';

/**
 * AppData
 * @typedef {{
 *      FEATURE_ENABLED_ABANDONED_CHECKOUT: boolean,
 *      FEATURE_ENABLED_PRODUCT_REVIEW: boolean,
 *      FEATURE_ENABLED_SHIPPING_NOTIFICATION: boolean,
 *      timezone: string,
 *      merchantType: string,
 *      isPriceMatchEnabled: boolean,
 *      integrationType: string,
 *      merchantRegistrationDate: (string | Date)
 *  }} AppData
 */

class AppDataLoaderReal {
    /**
     * @param {HhConfig} config
     */
    constructor(config) {
        this.config = config;
    }

    /**
     * @param {string} merchantCode
     * @returns {Promise<AppData>}
     */
    async loadData(merchantCode) {
        const merchantDataLoader = new MerchantDataLoader(this.config);
        const posLoader = new PosSystemDataLoaderReal(this.config);
        const settingsLoader = new SettingsDataLoaderReal(this.config);

        const [merchantData, settingsData, posData] = await Promise.all([
            merchantDataLoader.loadData(merchantCode),
            settingsLoader.loadData(merchantCode),
            posLoader.loadData(merchantCode),
        ]);

        const data = {
            FEATURE_ENABLED_ABANDONED_CHECKOUT: Number(settingsData.FEATURE_ENABLED_ABANDONED_CHECKOUT) === 1,
            FEATURE_ENABLED_PRODUCT_REVIEW: Number(settingsData.FEATURE_ENABLED_PRODUCT_REVIEW) === 1,
            FEATURE_ENABLED_SHIPPING_NOTIFICATION: Number(settingsData.FEATURE_ENABLED_SHIPPING_NOTIFICATION) === 1,
            integrationType: (posData && posData.productSource && posData.productSource.source_type) || 'empty',
            isPriceMatchEnabled: Number(merchantData.isPriceMatchEnabled) === 1,
            merchantRegistrationDate: merchantData.merchantRegistrationDate
                ? new Date(merchantData.merchantRegistrationDate)
                : new Date(new Date().getFullYear(), 0, 1), // default is 1st of January
            timezone: settingsData.timezone || this.config.timezone,
            merchantType: merchantData.merchantType || 'default',
        };

        return data;
    }
}

export default AppDataLoaderReal;
